/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Fade } from '@mui/material';
import Grid from '@mui/material/Grid';
// Wimss context
import {
  useWimssController,
  setIsMobile,
  setCurrentPage,
  setCurrentTexts,
} from 'context';

import { initTexts } from 'utils/syncState';

//import hero pictures and background images
import LookUp from 'assets/images/pictures/look-up.png';
import WimssTabs from 'layouts/WimssTabs';

//import Activities page text items
import { ActivityTabsList } from 'assets/web-contents/TextItems';

const ActivityHero = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${LookUp})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
        overflow: 'hidden',
        overflowY: 'auto',
        width: '100vw',
        height: '100%',
        position: 'relative',
      }}>
      <Fade
        in={true}
        style={{
          transitionDelay: 500,
        }}>
        <img
          src={LookUp}
          alt={'Bottom Up Coconuts'}
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
          }}
        />
      </Fade>
    </Box>
  );
};

const Activities = () => {
  const [controller, dispatch] = useWimssController();
  const { currentLanguage, isMobile, currentPage, currentTexts } = controller;

  const Page = 'activities';
  const { innerWidth: width } = window;

  const navigate = useNavigate();

  const [refreshActBtn, setRefreshActBtn] = useState(true);

  useEffect(() => {
    if (width <= 600) {
      setIsMobile(dispatch, true);
    } else setIsMobile(dispatch, false);
    setCurrentPage(dispatch, Page);
  }, []);

  useEffect(() => {
    // initHero(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (currentLanguage !== '') {
      setRefreshActBtn(false);
    }

    //set pageTexts
    let pageTxts = initTexts(currentLanguage, currentPage);
    setCurrentTexts(dispatch, pageTxts);
  }, [currentLanguage, currentPage]);

  useEffect(() => {
    if (currentTexts !== null && !refreshActBtn) setRefreshActBtn(true);
  }, [currentTexts]);

  return (
    <Box sx={{ flexGrow: 1, mt: 0 }}>
      <Grid
        container
        // columns={{ xs: 4, sm: 8, md: 12 }}
        direction='column'
        spacing={{ xs: 3, md: 4 }}>
        <Grid size={12}>
          <ActivityHero />
        </Grid>
        <Grid size={12} sx={{ mt: isMobile ? 0 : 0 }}>
          {currentTexts !== null && refreshActBtn && (
            <WimssTabs tabs={ActivityTabsList} />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Activities;
